// extracted by mini-css-extract-plugin
export default {"NumericRangeFeature":"wr_a bih_b bih_we"};